import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Button, Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import DeclarationGate from '../../components/DeclarationGate';

export default function ReviewerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static" sx={{ bgcolor: 'primary.main' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, cursor: 'pointer' }} onClick={() => navigate('/reviewer')}>
            OKC 2027 — Reviewer Portal
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2">{(user && user.name)}</Typography>
            <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'secondary.main', fontSize: 14 }}>
                {(user && user.name ? user.name.charAt(0).toUpperCase() : "?")}
              </Avatar>
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
              {(user && user.role) === 'facilitator' && (
                <MenuItem onClick={() => { navigate('/facilitator'); setAnchorEl(null); }}>Follow-up view</MenuItem>
              )}
              {(user && user.role) === 'admin' && (
                <MenuItem onClick={() => { navigate('/admin'); setAnchorEl(null); }}>Admin Panel</MenuItem>
              )}
              <MenuItem onClick={() => { logout(); navigate('/login'); }}>
                <Logout sx={{ mr: 1, fontSize: 18 }} /> Sign out
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <DeclarationGate onAccepted={() => window.location.reload()} />
      <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
